import { Box } from '@mui/system';
import { useForm, Controller } from 'react-hook-form';
import { Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import { emailMessageRequest, groupRequest } from 'src/models/CRM';
import useSendEmail from 'src/hooks/query/CRM/useSendEmail';
import TextEditor from 'src/components/TextEditor';

const inputStyle = {
  width: { xs: '100%', sm: '48%' },
  marginBottom: '30px'
};

interface Props {
  setOpen: Function;
  selectedCustomers: { id: number; type: string }[];
}
const SendEmailForm = ({ setOpen, selectedCustomers }: Props) => {
  const {
    handleSubmit,
    control,
    setError,
    watch,
    reset,
    formState: { errors }
  } = useForm<emailMessageRequest>({
    defaultValues: {}
  });

  const sendEmail = useSendEmail();
  const queryClient = useQueryClient();

  const onSubmit = (data) => {
    console.log(errors);

    sendEmail
      .mutateAsync(
        { ...data, data: selectedCustomers },
        {
          onSuccess: () => {
            toast.success('Email Sent Successfully');
            setOpen(false);
          }
        }
      )
      .catch((error) => {
        toast.error('Something went wrong, please try again later.');
      });
  };

  return (
    <Box>
      <>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '1.5rem'
              }}
            ></Box>
            <Controller
              name="subject"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  sx={inputStyle}
                  {...field}
                  label="Email Subject"
                  placeholder="Email Subject"
                  required
                  error={!!errors?.subject}
                  helperText={errors?.subject?.message}
                />
              )}
            />
            {/* <Controller
              name="content"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Eamil Content"
                  placeholder="Eamil Content"
                  required
                  sx={inputStyle}
                  error={!!errors?.content}
                  helperText={errors?.content?.message}
                />
              )}
            /> */}

            <Controller
              name="content"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Stack height="400px" spacing={1}>
                  <Typography color="#444">Email Content</Typography>
                  <TextEditor value={field.value} setValue={field.onChange} />
                </Stack>
              )}
            />

            <Box sx={{ marginLeft: '16px', marginTop: '70px' }}>
              <LoadingButton
                loadingPosition="start"
                variant="contained"
                fullWidth
                type="submit"
                loading={sendEmail.isLoading}
                disabled={
                  !watch('content') || watch('content') == '<p><br></p>'
                }
              >
                Send Email
              </LoadingButton>
            </Box>
          </div>
        </form>
      </>
    </Box>
  );
};

export default SendEmailForm;
